<template>
  <div>
    <b-container style="max-width: 500px;">
      <b-row>
        <b-col>
          <h1 class="text-left mb-2" v-if="!kkvForm">Bejelentkezés</h1>
          <div class="text-left my-3" v-if="relayState">
            <hr class="mt-3 mb-3" />
            <b style="color: #00903C;">Sikeres Ügyfélkapus azonosítás!</b>
            <br />

            <p class="mt-2">
              Amennyiben Ön már rendelkezik VALI.HU fiókkal, első alkalommal jelentkezzen be a megszokott módon,
              ellenkező esetben
              <span @click="goToRegisterWithRelay" class="registration-button">regisztráljon.</span>
            </p>
            <p>
              Amennyiben korábban a regisztrációt valamely közösségi-platform (Google, Facebook, LinkedIn) fiókjával
              végezte el, úgy kérjük az ahhoz tartozó e-mail címet, és a Vali.hu regisztráció során megadott jelszót
              adja meg a fiók Ügyfélkapuval történő összekapcsolásához.
            </p>
            <hr class="mt-3 mb-3" />
          </div>
          <b-row class="mt-4">
            <b-col cols="6">
              <b-button class="social rounded google" @click="socialLogin('google')" :disabled="!!relayState">
                <GooglePlusIcon />Google
              </b-button>
            </b-col>
            <b-col cols="6">
              <b-button v-if="!relayState" class="social rounded clientgate" @click="getKauResponse">
                <client-gate-svg />Ügyfélkapu
              </b-button>

              <b-button v-else class="social rounded clientgate" @click="kauLogout">
                <client-gate-svg />Ügyfélkapu kijelentkezés
              </b-button>
            </b-col>
            <b-col cols="6" class="mt-3">
              <b-button class="social rounded facebook" @click="socialLogin('facebook')" :disabled="!!relayState">
                <FacebookIcon />Facebook
              </b-button>
            </b-col>

            <b-col cols="6" class="mt-3">
              <b-button class="social rounded linkedin" @click="socialLogin('linkedin')" :disabled="!!relayState">
                <LinkedInIcon />LinkedIn
              </b-button>
            </b-col>
          </b-row>

          <hr class="mt-3 mb-3" />
          <b-col class="p-0 m-0 mb-5">
            <b-form>
              <b-row>
                <b-col cols="12" lg="6">
                  <b-form-group id="input-group-1" label-for="login_email" description>
                    <label>Email</label>
                    <b-form-input
                      id="login_email"
                      type="email"
                      required
                      placeholder="Email cím"
                      v-model="email"
                      class="border"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="12" lg="6">
                  <label>Jelszó</label>
                  <b-input-group id="input-group-2" label-for="login_password" description>
                    <b-form-input
                      id="login_password"
                      :type="passwordFieldType"
                      required
                      placeholder="Jelszó"
                      class="border"
                      v-model="password"
                      autocomplete="on"
                    >
                    </b-form-input>
                    <b-input-group-append>
                      <span class="input-group-text border" @click="switchPasswordVisibility">
                        <eye-icon v-if="passwordFieldType == 'password'" title="Jelszó megjelenítése" />
                        <eye-off-icon v-if="passwordFieldType == 'text'" title="Jelszó elrejtése" />
                      </span>
                    </b-input-group-append>
                  </b-input-group>
                </b-col>
                <b-col cols="12" lg="6">
                  <b-button
                    type="submit"
                    variant="primary"
                    @click.prevent="onLoginSubmit"
                    :disabled="isLoading"
                    class="mt-4 mb-3 w-100"
                  >
                    <b-spinner small v-if="isLoading"></b-spinner>
                    <span class="sr-only" v-if="isLoading">Betöltés...</span>
                    <span v-if="!isLoading">Bejelentkezés</span>
                  </b-button>
                </b-col>
                <b-col cols="12" lg="6">
                  <div v-if="!kkvForm" class="mt-3 text-right">
                    <router-link to="/forgot" @click.native="closeLoginModalBox" style="font-weight: bold"
                      >Elfelejtettem a jelszavam</router-link
                    >
                  </div>
                  <div v-if="kkvForm">
                    <b-button
                      type="submit"
                      variant="secondary"
                      @click.prevent="onRegistrationSubmit"
                      :disabled="isLoading"
                      class="mt-4 mb-3 w-100"
                      style="background: transparent;"
                    >
                      <span>Regisztráció</span>
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-form>
            <template v-if="!kkvForm && !isFundMapRegistration">
              <hr class="mt-3 mb-3" />
              Nincs még fiókja?
              <router-link to="/register" v-on:click.native="closeLoginModalBox">Regisztráljon</router-link>
            </template>
            <template v-if="isFundMapRegistration">
              <hr class="mt-3 mb-3" />
              Nincs még fiókja?
              <span @click="fundMapNavigateToRegister" class="registration-button">Regisztráljon</span>
            </template>
          </b-col>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import queryString from 'query-string'
import EyeIcon from 'vue-material-design-icons/Eye.vue'
import EyeOffIcon from 'vue-material-design-icons/EyeOff.vue'
import FacebookIcon from 'vue-material-design-icons/Facebook.vue'
import GooglePlusIcon from 'vue-material-design-icons/GooglePlus.vue'
import LinkedInIcon from 'vue-material-design-icons/Linkedin.vue'
import { mapGetters } from 'vuex'
import * as FundMapApi from '../api/fundMap'
import * as KauApi from '../api/kau'
import * as UserApi from '../api/user'
import ClientGateSvg from './svg/ClientGate.vue'

// DAP audience constant as per 2023. évi CIII. törvény 39. § (2)
const DAP_AUDIENCE = 'urn:eksz.gov.hu:1.0:azonositas:kau:3:dap:qr'

export default {
  name: 'LoginForm',
  props: {
    modalForm: { type: String },
    kkvForm: { type: Boolean, default: false }
  },
  components: {
    FacebookIcon,
    GooglePlusIcon,
    LinkedInIcon,
    EyeIcon,
    EyeOffIcon,
    ClientGateSvg
  },
  data() {
    return {
      email: '',
      password: '',
      selectedCompanyId: '',
      passwordFieldType: 'password',
      isFundMapRegistration: false,
      fundMapStoreParams: {},
      relayState: '',
      avoidKauSessionDestroy: false
    }
  },
  mounted() {
    if (this.$route.path.includes('/fund-map')) {
      this.isFundMapRegistration = true
    }
    this.fundMapStoreParams = {
      company: this.fundMapCompany,
      category: this.selectedFundMapCategory,
      attributes: this.fundMapCompanyAttributes
    }
  },
  computed: {
    ...mapGetters([
      'isLoading',
      'isSearchCompany',
      'isAuthenticated',
      'userCompanies',
      'fundMapCompany',
      'selectedFundMapCategory',
      'fundMapCompanyAttributes'
    ]),
    forgotLinkClass() {
      if (this.modalForm != null || this.kkvForm != null) return 'white-color'
      else return 'green-color'
    }
  },
  methods: {
    async getKauResponse() {
      try {
        const response = await KauApi.createRequest({
          callbackUrl: `${window._env_.VUE_APP_API_URL}/api/v1/kau/processResponse`
        })

        const RelayState = response.relayState
        const SAMLRequest = response.samlRequest

        const url = `${window._env_.VUE_APP_KAU_BASE_URL}/proxy/saml/authnrequest`

        const form = document.createElement('form')
        form.action = url
        form.method = 'POST'

        const samlInput = document.createElement('input')
        samlInput.type = 'hidden'
        samlInput.name = 'SAMLRequest'
        samlInput.value = SAMLRequest

        const relayStateInput = document.createElement('input')
        relayStateInput.type = 'hidden'
        relayStateInput.name = 'RelayState'
        relayStateInput.value = RelayState

        const audienceInput = document.createElement('input')
        audienceInput.type = 'hidden'
        audienceInput.name = 'Audience'
        audienceInput.value = DAP_AUDIENCE

        form.appendChild(relayStateInput)
        form.appendChild(samlInput)
        form.appendChild(audienceInput)

        document.body.appendChild(form)
        form.submit()
      } catch (error) {
        console.error('KAU request failed:', error)
        this.$store.dispatch('notify', {
          newNotification: {
            type: 'danger',
            message: 'Az Ügyfélkapus azonosítás során hiba történt. Kérjük, próbálja újra később.'
          }
        })
      }
    },
    async kauLogout(relayState) {
      try {
        await UserApi.kauLogout(relayState)
        this.$router.push('/')
      } catch (error) {
        console.error('KAU logout failed:', error)
        this.$store.dispatch('notify', {
          newNotification: {
            type: 'warning',
            message: 'A kijelentkezés során hiba történt. Kérjük, próbálja újra.'
          }
        })
      }
    },
    switchPasswordVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
    filteredUserCompany(selectedId) {
      return this.userCompanies.filter(function(company) {
        return company.companyId === selectedId
      })
    },
    async redirectHandler() {
      const { companyId } = queryString.parse(location.search)
      const getCompanyQueryParams = { value: companyId }

      if (this.kkvForm) {
        if (companyId) {
          const filteredUserCompany = this.filteredUserCompany(companyId)
          if (filteredUserCompany.length != 0) {
            this.$router.push('private-add-company')
            return
          }

          await this.$store.dispatch('getCompany', getCompanyQueryParams)

          this.$router.push({
            name: 'Result',
            query: { companyId: this.$route.query.companyId }
          })

          return
        }
        this.$router.push('/kkv-qualifier')
        return
      }

      if (companyId) {
        await this.$store.dispatch('getCompany', getCompanyQueryParams)
        this.$router.push({
          name: 'CompanyDetails',
          query: { companyId: this.$route.query.companyId },
          params: {
            flowSource: 'Login'
          }
        })
        return
      }

      if (this.isAuthenticated) {
        if (this.$route.path === '/fund-map') {
          return
        }
        this.$router.push('/home')
      }
    },
    async onLoginSubmit() {
      const loginData = { email: this.email, password: this.password }
      const { companyId } = queryString.parse(location.search)
      const getCompanyQueryParams = { value: companyId }
      const isSearchCompany = this.isSearchCompany

      if (loginData.email.length == 0 || loginData.password.length == 0) {
        this.$store.dispatch('notify', {
          newNotification: { type: 'warning', message: 'Az összes mező kitöltése kötelező!' }
        })
      } else {
        try {
          await this.$store.dispatch('login', loginData)
          if (this.isFundMapRegistration) {
            return this.closeLoginModalBox()
          }

          if (this.relayState) {
            const fullName = await this.getKauFullName(this.relayState)
            await UserApi.updateUser({
              relayState: this.relayState,
              fullName: fullName
            })
            await this.$store.dispatch('getMe')
          }

          if (companyId && isSearchCompany) {
            await this.$store.dispatch('getCompany', getCompanyQueryParams)
            this.$router.push({
              name: 'CompanyDetails',
              query: { companyId: this.$route.query.companyId },
              params: {
                flowSource: 'Login'
              }
            })
          } else if (companyId) {
            await this.$store.dispatch('getCompany', getCompanyQueryParams)
            this.$router.push({
              name: 'SoleProprietorshipDetails',
              query: { companyId: this.$route.query.companyId },
              params: {
                flowSource: 'Login'
              }
            })
          }
          await this.redirectHandler()
          this.closeLoginModalBox()
        } catch (err) {
          if (err.response?.status == 401) {
            this.$store.dispatch('notify', {
              newNotification: { type: 'danger', message: 'Hibás email cím vagy jelszó.' }
            })
          }
        }
      }
    },
    async onRegistrationSubmit() {
      const { companyId } = queryString.parse(location.search)
      if (companyId) this.$router.push(`/register?companyId=${companyId}&redir=kkv-result`)
      else this.$router.push('register?redir=kkv-qualifier')
    },
    async socialLogin(social) {
      try {
        await this.$auth.authenticate(`${social}Log`)
        await this.$store.dispatch('getMe')
        this.closeLoginModalBox()
      } catch (err) {
        this.$store.dispatch('notify', {
          newNotification: { type: 'danger', message: 'A belépés nem sikerült.' }
        })
        return
      }
      await this.socialRedirectHandler()
    },
    async socialRedirectHandler() {
      const { companyId } = queryString.parse(location.search)
      const getCompanyQueryParams = { value: companyId }
      try {
        if (companyId) {
          await this.$store.dispatch('getCompany', getCompanyQueryParams)
          this.$router.push({
            name: 'CompanyDetails',
            query: { companyId: this.$route.query.companyId },
            params: {
              flowSource: 'Login'
            }
          })
        } else {
          if (this.isFundMapRegistration) {
            return this.closeLoginModalBox()
          }
          this.$router.push('/home')
        }
      } catch (err) {
        this.$store.dispatch('notify', {
          newNotification: { type: 'warning', message: 'Hiba történt a cég lekérdezése során.' }
        })

        if (this.isAuthenticated) {
          this.$router.push('/home')
        }
      }
    },
    closeLoginModalBox() {
      this.$root.$emit('bv::hide::modal', 'login-modal')
    },
    redirectToRegister() {
      this.closeLoginModalBox()
      this.$router.push('/register')
    },
    async fundMapNavigateToRegister() {
      if (this.$route.path.includes('/fund-map/create-company')) {
        try {
          const id = await FundMapApi.sendFundmapDataToCacheService(this.fundMapCompany.imaginaryCompany)
          this.$router.push(`/register?sessionId=${id}`)
          this.closeLoginModalBox()
        } catch (e) {
          console.error('Error navigating to fund map register:', e)
          this.$store.dispatch('notify', {
            newNotification: { type: 'danger', message: 'Hiba történt a regisztrációs folyamat során.' }
          })
        }
      } else {
        try {
          const id = await FundMapApi.sendFundmapDataToCacheService(this.fundMapStoreParams)
          this.$router.push(`/register?sessionId=${id}`)
          this.closeLoginModalBox()
        } catch (e) {
          console.error('Error navigating to fund map register:', e)
          this.$store.dispatch('notify', {
            newNotification: { type: 'danger', message: 'Hiba történt a regisztrációs folyamat során.' }
          })
        }
      }
    },
    goToRegisterWithRelay() {
      this.avoidKauSessionDestroy = true
      this.$router.push(`/register?relayState=${this.relayState}`)
    },
    async getKauFullName(relayState) {
      try {
        const fullName = await KauApi.getFullName(relayState)
        return fullName
      } catch (error) {
        console.error('Error getting KAU full name:', error)
        return '' // Return empty string if name fetch fails
      }
    }
  },
  created() {
    this.relayState = this.$route.query.relayState
  },
  beforeDestroy() {
    if (this.relayState && !this.avoidKauSessionDestroy) {
      this.kauLogout(this.relayState)
    }
  }
}
</script>

<style scoped>
.social {
  min-width: 100px;
  width: 100%;
  padding-left: 10px;
  font-size: 14px;
  color: white;
  border: 0;
  min-height: 24px;
  line-height: 24px;
  display: flex;
  align-items: center;
  display: inline-flex;
  justify-content: center;
}

.social.facebook {
  background-color: #4267b2;
}

.social.facebook:hover {
  background-color: #4267b2 !important;
  opacity: 0.9;
}

.social.google {
  background-color: #db4437;
}

.social.google:hover {
  background-color: #db4437 !important;
  opacity: 0.9;
}

.social.linkedin {
  background-color: #0e76a8;
}

.social.linkedin:hover {
  background-color: #0e76a8 !important;
  opacity: 0.9;
}

.social.clientgate {
  background-color: #772860;
}

@media all and (max-width: 767px) {
  .social.clientgate {
    font-size: 14px;
  }
}

@media all and (max-width: 467px) {
  .social.clientgate {
    font-size: 13px;
  }
}

@media all and (max-width: 445px) {
  .social.clientgate {
    font-size: 9px;
  }
}

.social.clientgate:disabled {
  background-color: #772860 !important;
  opacity: 0.3;
}

.social svg {
  margin-right: 10px;
}

@media (max-width: 576px) {
  .social svg {
    position: relative;
    margin-right: 10px;
    margin-top: -3px;
  }
}

a {
  text-decoration: underline;
}

.green-color {
  color: #6f6f6f;
}

.white-color {
  color: white;
}

.kkv-input-color {
  color: white;
  background-color: rgba(0, 144, 60, 0.52) !important;
  border-bottom: 1px solid white !important;
}

.kkv-input-color::placeholder {
  color: white;
}

.kkv-button {
  border: 1px solid white;
  width: 90%;
  padding-left: 30px;
  position: relative;
  margin-top: 5px;
  margin-bottom: 5px;
  min-width: 90px;
  background-color: white;
  color: #00903c;
}

.kkv-button:hover {
  background-color: white;
  color: #00903c;
}

.kkv-button-radius {
  border-radius: 15px;
}

.button-text-size {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  padding: 8px 0px 8px 0px;
}

.kkv-social-btn {
  color: white !important;
}

.kkv-social-btn:hover {
  border: 1px solid white !important;
}

.registration-button {
  color: #00903c;
  cursor: pointer;
}

.registration-button:hover {
  text-decoration: underline;
}
</style>
